import { render, staticRenderFns } from "./HistoricoInforme.vue?vue&type=template&id=51c64193&"
import script from "./HistoricoInforme.vue?vue&type=script&lang=ts&"
export * from "./HistoricoInforme.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('51c64193', component.options)
    } else {
      api.reload('51c64193', component.options)
    }
    module.hot.accept("./HistoricoInforme.vue?vue&type=template&id=51c64193&", function () {
      api.rerender('51c64193', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/HistoricoInforme/HistoricoInforme.vue"
export default component.exports